import { useCallback, useEffect, useState } from 'react'
import { salesReportRepository } from '../../data/repositories/SalesReportRepositoryImpl'
import { SalesReportData } from '../../domain/entities/SalesReport'
import { GetSalesReportUseCase } from '../../domain/usecases/GetSalesReportUseCase'

const getSalesReportUseCase = new GetSalesReportUseCase(salesReportRepository)

export const useSalesReport = () => {
  const [data, setData] = useState<SalesReportData | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchSalesReport = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const report = await getSalesReportUseCase.execute()
      setData(report)
    } catch (err: unknown) {
      const errorVal = err as Error
      setError(errorVal.message || 'Failed to fetch the sales report.')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchSalesReport()
  }, [fetchSalesReport])

  return { data, loading, error, refresh: fetchSalesReport }
}
